"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var hooks_1 = require("../../hooks");
var FormatText_1 = __importDefault(require("../FormatText"));
var NavView_1 = __importDefault(require("../NavView"));
var Permission_1 = __importDefault(require("../Permission"));
var TabItem_1 = __importDefault(require("./TabItem"));
var Title = antd_1.Typography.Title;
var TabPane = antd_1.Tabs.TabPane;
var mountTabConfig = function (children) {
    var result = {
        tabIdList: [],
        tabPaneList: [],
    };
    if (children) {
        react_1.default.Children.forEach(children, function (child, index) {
            var tabChild = child;
            var _a = tabChild.props, id = _a.id, icon = _a.icon, title = _a.title;
            var TabComponent = react_1.default.createElement(TabItem_1.default, { icon: icon, text: title || "Tab " + index });
            var tabId = id || "section_" + index;
            result.tabIdList.push(tabId);
            result.tabPaneList.push(react_1.default.createElement(TabPane, { tab: TabComponent, key: tabId }, child));
        });
    }
    return result;
};
var CompositeViewContent = function (_a) {
    var toolbar = _a.toolbar, children = _a.children;
    hooks_1.useWorkspaceToolbar(toolbar);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
var CompositeView = function (props) {
    var children = props.children, navPath = props.path, toolbar = props.toolbar, viewPermission = props.viewPermission, editPermission = props.editPermission, navProps = __rest(props, ["children", "path", "toolbar", "viewPermission", "editPermission"]);
    var _a = react_1.useMemo(function () { return mountTabConfig(children); }, [children]), tabIdList = _a.tabIdList, tabPaneList = _a.tabPaneList;
    if (tabPaneList.length <= 1) {
        return (react_1.default.createElement(Permission_1.default, { viewPermission: viewPermission, editPermission: editPermission },
            react_1.default.createElement(NavView_1.default, __assign({}, navProps, { path: navPath }),
                react_1.default.createElement(CompositeViewContent, { toolbar: toolbar }, children))));
    }
    return (react_1.default.createElement(Permission_1.default, { viewPermission: viewPermission, editPermission: editPermission },
        react_1.default.createElement(NavView_1.default, __assign({}, navProps, { path: "/:section(" + tabIdList.join('|') + ")?" + (navPath || ''), render: function (routerProps) {
                var _a = routerProps.match, path = _a.path, params = _a.params, history = routerProps.history;
                if (params.section) {
                    return (react_1.default.createElement(CompositeViewContent, { toolbar: toolbar },
                        react_1.default.createElement(antd_1.Tabs, { className: "ant-app-composite-tabs", activeKey: params.section, animated: false, onChange: function (activeKey) {
                                var url = react_router_1.generatePath(path, { section: activeKey });
                                history.push(url);
                            } }, tabPaneList)));
                }
                if (tabPaneList && tabPaneList[0] && tabPaneList[0].key) {
                    var url = react_router_1.generatePath(path, { section: tabPaneList[0].key.toString() });
                    return react_1.default.createElement(react_router_1.Redirect, { to: url });
                }
                return (react_1.default.createElement("div", { style: { padding: 24, textAlign: 'center' } },
                    react_1.default.createElement(Title, null,
                        react_1.default.createElement(FormatText_1.default, { id: "ui.messages.notabs" }))));
            } }))));
};
exports.default = CompositeView;
